import { Route, Routes, Navigate } from 'react-router-dom';
import router from './router';
import RouterAuth from '@/components/RouterAuth'; //可做鉴权   此处用来设置header title、微信分享鉴权

const initRouter = () => (
  <Routes>
    {router.map((item: any, index: number) => {
      return (
        <Route key={index} path={item.path}>
          {/* 设置链接中的可选参数 */}
          {item.meta.optional &&
            item.meta.optional.map((el: string, idx: number) => (
              <Route
                key={idx}
                path={`:${el}`}
                element={
                  <RouterAuth meta={item.meta}>
                    <item.element />
                  </RouterAuth>
                }
              />
            ))}
          <Route
            path=""
            element={
              <RouterAuth meta={item.meta}>
                <item.element />
              </RouterAuth>
            }
          />
        </Route>
      );
    })}
    <Route path="" element={<Navigate to="/index" replace />} />
    <Route path="*" element={<Navigate to="/error404" replace />} />
  </Routes>
);
export default initRouter;
